export function createCsv(
  uploader,
  surveyDefinition,
  answers,
  delimiter = ',',
  onSuccess = undefined
) {
  let output = ''

  const header = surveyDefinition.csvDefinition
    .map((col) => {
      const otherColName = (col) => `${col.options.slice(-1)[0]}_TEXT`
      const colWithOther = (col) =>
        `${col.columnName}${delimiter}${col.columnName}_${otherColName(col)}`
      const optionHeaders = (options, name) =>
        options.map((o) => `${name}_${o}`).join(delimiter)

      switch (col.type) {
        case 'single-col':
          return col.columnName
          break
        case 'single-col-other':
          return colWithOther(col)
          break
        case 'multi-col':
          return optionHeaders(col.options, col.columnName)
          break
        case 'multi-col-other':
          return (
            optionHeaders(col.options, col.columnName) +
            `${delimiter}${col.columnName}_${otherColName(col)}`
          )
          break
        case 'matrix':
          return optionHeaders(col.rows, col.columnName)
          break
        default:
          return col.columnName
      }
    })
    .join(delimiter)

  const data = surveyDefinition.csvDefinition
    .map((col) => {
      const otherVal = (col) => {
        return answers[`${col.questionName}-Comment`] || ''
      }
      const colText = (val) =>
        isNaN(val) ? `"${val.replace(/"/g, '""')}"` : val
      const valWithOther = (col, val) => {
        if (col.options.includes(val)) {
          return `${val}${delimiter}`
        } else {
          return `${col.options.slice(-1)[0]}${delimiter}${colText(
            otherVal(col)
          )}`
        }
      }

      const checkBoxVals = (options, val) =>
        options.map((o) => (val.includes(o) ? '1' : '')).join(delimiter)

      const val = answers[col.questionName] || col.default
      const answered = Object.keys(answers).includes(col.questionName)

      switch (col.type) {
        case 'single-col':
          return colText(val)
          break
        case 'single-col-other':
          if (!answered) return [...Array(2)].join(delimiter)
          return valWithOther(col, val)
          break
        case 'multi-col':
          if (!answered) return [...Array(col.options.length)].join(delimiter)
          return checkBoxVals(col.options, val)
          break
        case 'multi-col-other':
          if (!answered)
            return [...Array(col.options.length + 1)].join(delimiter)
          return (
            checkBoxVals(col.options.slice(0, -1), val) +
            (otherVal(col) === ''
              ? delimiter + delimiter
              : `${delimiter}1${delimiter}${colText(otherVal(col))}`)
          )
          break
        case 'matrix':
          return col.rows.map((r) => val[r]).join(delimiter)
        case 'raw-data':
          return colText(JSON.stringify(answers))
          break
        default:
          return colText(val)
      }
    })
    .join(delimiter)
  output += header
  output += '\n'
  output += data
  uploader.uploadDataAsFile(
    output,
    undefined,
    surveyDefinition.fileName + '.csv' || 'survey.csv',
    onSuccess
  )
}
